import * as React from "react";
import * as queryString from "query-string";
import { useHistory } from "react-router-dom";
import _ from "lodash";

import { TabbedNavigation } from "src/library/components/TabbedNavigation";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import ConnectorOrderExportTab from "src/modules/connector/components/ConnectorOrderExportIssuesTab";
import ConnectorOrderImportTab from "src/modules/connector/components/ConnectorOrderImportIssuesTab";
import {
  apiIssueManagementJobs,
  filterHelper
} from "src/core/process-job/components/processJobTableUtils";
import ProcessJobsQueueTable from "src/core/process-job/components/ProcessJobsTable";

/**
 * Mangage connector issues for admins
 * Contains 2 tabs
 * - Connector export issues
 * - Connector import issues
 */

const ConnectorIssueManagementPage: React.ReactFCWithChildren<PageProps<unknown>> = ({ title, ...props }) => {
  const { location } = useHistory();
  const query = queryString.parse(location.search);

  const nonOrderProcessJobsTabs = React.useMemo(() => {
    return apiIssueManagementJobs.map(job => {
      //Create title from name
      const jobTitle = job.split("api-")[ 1 ].split("-").map(word => {
        return _.startCase(word);
      }
      ).join(" ");

      return {
        title: jobTitle,
        name: job,
        content: () => (
          <ProcessJobsQueueTable
            specificFilters={filterHelper([ job ])}
            tableName = {jobTitle}
            terminology = {props.terminology}
            excludedColumns = {[ "triggeredBy", "triggeredByType" ]}
            jobLinkPrefix = "/admin/api-issue-management/"

          />
        )
      };
    });
  }, [ props.terminology ]);

  const tabs = React.useMemo(() => {
    const issueManagementTabs = [
      {
        title: "Order exports",
        name: "export",
        content: () => (
          <>
            <ConnectorOrderExportTab
              history={props.history}
              terminology={props.terminology}
            />
          </>
        )
      },
      {
        title: "Order imports",
        name: "import",
        content: () => (
          <>
            <ConnectorOrderImportTab
              history={props.history}
              terminology={props.terminology}
            />
          </>
        )
      }
    ];

    return issueManagementTabs;
  }, [ props.history, props.terminology ]);

  return (
    <Layout
      title={title}
      {...props}
    >
      <MainContentWrapper fill>
        <TabbedNavigation
          defaultTab={query.type && typeof query.type === "string" ? query.type : "export"}
          className="tab-navigator"
          tabs={[ ...tabs, ...nonOrderProcessJobsTabs ]}
        />
      </MainContentWrapper>

    </Layout>
  );
};

export default ConnectorIssueManagementPage;
